import { gql } from "@apollo/client";
import { QueryType } from "gui/BrowseQueriesPage/api/queryItem";
import { QueryElementFragment } from "lib/types/graphql";

interface QueryElementType extends QueryType {
  folder?: {
    id: string;
    color: string;
    icon: string;
    name: string;
  };
}

export function toQueryElementType(
  query: QueryElementFragment
): QueryElementType {
  return {
    id: query.id,
    name: query.name ?? "",
    created_at: query.created_at,
    updated_at: query.updated_at,
    folder: query.folder
      ? {
          id: query.folder.id,
          color: query.folder.color,
          icon: query.folder.icon,
          name: query.folder.name,
        }
      : undefined,
    owner: {
      type: query.owner.type,
      handle: query.owner.handle,
      id: query.owner.id,
      profile_image_url: query.owner.profile_image_url ?? undefined,
    },
    is_private: query.is_private,
    matview_id: query.matview_id ?? undefined,
    tags: query.tags ?? [],
    favoriteCount: query.favorites ?? 0,
  };
}

export const QueryElement = gql`
  fragment QueryElement on QueryResult {
    id
    name
    created_at
    updated_at
    matview_id
    folder {
      id
      color
      icon
      name
    }
    owner {
      id
      type
      handle
      profile_image_url
    }
    is_private
    matview_id
    tags
    favorites
  }
`;
